import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import ResourceList from "./resource-list.vue";
import AddResourceToUsed from "./add-resource-to-used.vue";
import AssetCard from "@com/components/asset-card/index.vue";
import VideoDuration from "./video-duration.vue";
import { AssetStatus } from "@pt/enums/assets";
export default defineComponent({
    props: {
        resources: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    components: {
        ResourceList: ResourceList,
        AddResourceToUsed: AddResourceToUsed,
        AssetCard: AssetCard,
        VideoDuration: VideoDuration
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var isAdd = // 兼容历史资源无status状态的情况
        function isAdd(status) {
            return status !== AssetStatus.Transcoding && status !== AssetStatus.Pending && status !== AssetStatus.Error;
        };
        var getComponents = function() {};
        var handleAddResource = function(res) {
            emit("addResource", res);
        };
        // 转码失败重试
        var retryEvent = function(id) {
            emit("retry", id);
        };
        return {
            AssetStatus: AssetStatus,
            retryEvent: retryEvent,
            handleAddResource: handleAddResource,
            isAdd: isAdd,
            getComponents: getComponents
        };
    }
});
